module.exports = __webpack_public_path__ + "img/1948-Kleine-Zeitung.473e8d66.jpg";